// extracted by mini-css-extract-plugin
export var wrapper = "categoryList-module--wrapper--3pOwx";
export var labelIcon = "categoryList-module--labelIcon--4wgDI";
export var ul = "categoryList-module--ul--1Hnby";
export var li = "categoryList-module--li--2kJc8";
export var postCount = "categoryList-module--postCount--1huRU";